/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  DependencyType,
  AssociatedPersonItem,
  MappedColumnArray,
  TemplateType,
} from './questionTypes';

export function getRenderTypes(selectedQuestionType: any): boolean {
  if (
    selectedQuestionType?.QuestionType?.Description === 'Lookup' ||
    selectedQuestionType?.QuestionType?.Description === 'Choice' ||
    selectedQuestionType?.QuestionType?.Description === 'Text' ||
    selectedQuestionType?.QuestionType?.Description === 'Link'
  )
    return true;
  else return false;
}

export function getQuestionTypeDetails(
  data: any,
  selectedQuestionType: any,
  mappedColumns: MappedColumnArray,
  lookupDependency: DependencyType,
): any {
  if (selectedQuestionType && !getRenderTypes(selectedQuestionType)) {
    const questionTypeOption = {
      ...selectedQuestionType?.QuestionTypeOption,
      Id: selectedQuestionType && selectedQuestionType?.QuestionTypeOption?.Id, // can change in edit
      IsNeverSentToAccount: data?.IsNeverSentToAccount,
      IsNotSentToAccountIfNoAnswer: data?.IsNotSentToAccountIfNoAnswer,
      IsRequired: data?.IsRequired,
    };
    return questionTypeOption;
  }
  if (selectedQuestionType?.QuestionType?.Description === 'Text') {
    const questionTypeOption = {
      ...selectedQuestionType?.QuestionTypeOption,
      Id: selectedQuestionType && selectedQuestionType?.QuestionTypeOption?.Id, // can change in edit
      IsNeverSentToAccount: data?.IsNeverSentToAccount,
      IsNotSentToAccountIfNoAnswer: data?.IsNotSentToAccountIfNoAnswer,
      IsRequired: data?.IsRequired,
      TextQuestionTypeFormat: null,
      TextQuestionTypeFormatId: data?.TextQuestionTypeFormatId,
      Type: data?.Type,
      DefaultValue: data?.DefaultValue,
    };
    return questionTypeOption;
  }
  if (selectedQuestionType?.QuestionType?.Description === 'Link') {
    const questionTypeOption = {
      ...selectedQuestionType?.QuestionTypeOption,
      Id: selectedQuestionType && selectedQuestionType?.QuestionTypeOption?.Id, // can change in edit
      IsNeverSentToAccount: data?.IsNeverSentToAccount,
      IsNotSentToAccountIfNoAnswer: data?.IsNotSentToAccountIfNoAnswer,
      IsRequired: data?.IsRequired,
      Type: data?.Type,
      LinkDescription: data?.LinkDescription,
      Url: data?.Url,
    };
    return questionTypeOption;
  }
  if (selectedQuestionType?.QuestionType?.Description === 'Lookup') {
    const questionTypeOption = {
      $type: 'LookupQuestionTypeOption',
      Id: selectedQuestionType && selectedQuestionType?.QuestionTypeOption?.Id, // can change in edit
      IsNeverSentToAccount: data?.IsNeverSentToAccount,
      IsNotSentToAccountIfNoAnswer: data?.IsNotSentToAccountIfNoAnswer,
      IsRequired: data?.IsRequired,
      CustomLookup: null,
      CustomLookupId: data?.CustomLookupTableId || null,
      CustomLookupTableId: data?.CustomLookupTableId,
      MappedLookupColumns: data?.CustomLookupTableId ? [...mappedColumns] : [],
      Dependencies: [...lookupDependency],
    };
    return questionTypeOption;
  }
  if (selectedQuestionType?.QuestionType?.Description === 'Choice') {
    const questionTypeOption = {
      ...selectedQuestionType?.QuestionTypeOption,
      Id: selectedQuestionType && selectedQuestionType?.QuestionTypeOption?.Id, // can change in edit
      IsNeverSentToAccount: data?.IsNeverSentToAccount,
      IsNotSentToAccountIfNoAnswer: data?.IsNotSentToAccountIfNoAnswer,
      IsRequired: data?.IsRequired,
      Type: data?.ChoiceType,
    };
    return questionTypeOption;
  }
}

export function getPersonAssociation(
  data: any,
  associatedPersons: Array<AssociatedPersonItem>,
): number {
  const personAssociation = associatedPersons.find(
    item => item.id === data?.PersonAssociation,
  );
  let personAssociationId = -1;
  if (personAssociation && personAssociation.name === 'None')
    personAssociationId = 2;
  if (personAssociation && personAssociation.name === 'Caller')
    personAssociationId = 0;
  if (personAssociation && personAssociation.name === 'Person of concern')
    personAssociationId = 1;

  return personAssociationId;
}

//Question Save & dependency add issue saved by adding a filtering condition inside if
//It is done for choice questions in order to sent Question Option Value as Zero during initial save
export function getQuestionOptions(
  selectedQuestionType: any,
  questionTemplateOptions: TemplateType,
) {
  const tempOption = [...questionTemplateOptions];
  const questionOptions =
    tempOption &&
    tempOption
      .filter(tempitem => tempitem.IncludeByDefault === true)
      .map((tempItem: any) => {
        if (
          selectedQuestionType.Id === selectedQuestionType.QuestionTemplateId &&
          selectedQuestionType.QuestionTypeOptions_Id !== undefined
        ) {
          return {
            ...tempItem,
            Id: 0,
          };
        } else {
          return {
            ...tempItem,
          };
        }
      });

  if (selectedQuestionType?.QuestionType?.Description === 'Choice') {
    return questionOptions;
  } else return [];
}

export function formatQuestionOptionsData(
  questionTemplateOptions: any,
  receivedQuestionParams: any,
) {
  const tempQuestionTemplateOptions = questionTemplateOptions.map(
    (item: any) => {
      return {
        ...item,
        QuestionTemplateOptionId: item.QuestionTemplateOptionId
          ? item.QuestionTemplateOptionId
          : item.Id,
      };
    },
  );

  const formatQuestionOptions =
    tempQuestionTemplateOptions &&
    tempQuestionTemplateOptions.map((questionTemplateItem: any) => {
      const tempItem = receivedQuestionParams.find(
        (item: any) =>
          item.QuestionTemplateOptionId ===
          questionTemplateItem.QuestionTemplateOptionId,
      );
       if (!tempItem || !Object.keys(tempItem).length) {
        return {
          ...questionTemplateItem,
          Id: 0,
          IncludeByDefault: false,
        };
      } else {
        return {
          ...questionTemplateItem,
          ...tempItem,
          IncludeByDefault: true,
        };
      }
    });
  return formatQuestionOptions;
}
